(ns hai.ui.components.button
  (:require
   [garden.selectors :as gse]
   [lambdaisland.ornament :as o]))

(o/defstyled outline-button :button
  :py-2 :px-4 :border :rounded
  :bg-transparent :text-primary-700 :border-primary-500
  :font-semibold
  :inline-flex :items-center :gap-1
  [:&:enabled :hover:bg-primary-500 :hover:text-white :hover:border-transparent]
  [:&:disabled :bg-gray-300 :text-gray-700 :border-gray-300])

(o/defstyled basic-button :button
  :p-2 :hover:bg-gray-100 :rounded
  {:background-color "transparent"}
  [:&:active :bg-gray-200])

;; Blue border and text
(o/defstyled action-button basic-button
  :border :border-1
  {:color "#3563FA" :border-color "#3563FA"} ;; primary-700
  [:* {:fill "#3563FA"}] ;; SVG
  [:&:hover {:background-color "#F1F9FF"}] ;; primary-25
  [:&:focus {:box-shadow "0px 0px 0px 2px #DCF0FF"}]
  [:&:disabled :border-white
   {:background-color "#E7ECF3" ;; blue-gray-100
    :color "#A8B0BE"} ;; gray-400
   [:* {:fill "#A8B0BE"}]] ;; gray-400
  ["&:not([disabled]):active"
   :bg-primary-700
   :text-white
   [:* :fill-white]
   :border-white])

(o/defstyled borderless-button basic-button
  :border-none
  [:path {:fill "#6d778b"}]
  [:&:hover [:path {:fill "#A8B0BE"}]])

(o/defstyled pale-blue-button basic-button
  :border-none
  {:background-color "#f1f9ff"
   :color "#3563FA"
   :border-color "#3563FA"} ;; primary-700
  [:* {:fill "#3563FA"}] ;; SVG
  [:&:hover {:background-color "#f1f9ff"
             :filter "brightness(101%)"}]
  [:&:active {:filter "brightness(102%)"}]
  [:&:focus {:background-color "#f1f9ff"
             :box-shadow "0px 0px 0px 2px #DCF0FF"}])

(o/defstyled pale-red-hover-button basic-button
  "Button which looks like a basic-button, but turns red when
  hovered/activated/focused"
  [:&:hover :bg-red-100 :text-red-600 :border-red-200]
  [:&:active :bg-red-300 :text-red-700 :border-red-200]
  [:&:focus :bg-red-200  :text-red-600 :border-red-200
   {:box-shadow "0px 0px 0px 2px #DCF0FF"}])

;; Button which only shows its shape when hovered/activated/focused
;; Not yet rounded, add the appropriate amount of rounding locally
(o/defstyled hidden-button :button
  :text-black :text-sm :fill-primary :p-3 :border-1 :border-transparent :min-w-fit
  [:&:hover :bg-blue-50]
  [:&:active {:filter "brightness(95%)"}]
  [:&:focus :border-gray-300]
  [:* :inline-block])

;; Starting to copy things more literally from Figma

(o/defstyled icon-button :button
  {:display "inline-flex"
   :height "40px"
   :padding "8px 43px 8px 42px"
   :justify-content "center"
   :align-items "center"
   :gap "12px"
   :flex-shrink "0"
   :border-radius "4px"
   :background "#FFF"
   :box-shadow "0px 1px 8px 0px rgba(16, 24, 40, 0.08), 0px 2px 5px 0px rgba(16, 24, 40, 0.04); "}
  [:&:focus {:box-shadow "0px 0px 0px 2px #F2F4F7"}]
  [:&:hover {:background "#F9FAFB"}]
  [:&:active {:background "#F2F4F7"
              :box-shadow "none"}])

(o/defstyled primary-button :button
  :text-white :bg-primary :px-4 :py-2 :inline-flex :items-center :justify-center :gap-2
  :rounded :shadow :flex-shrink-0
  [:&:focus {:box-shadow "0px 0px 0px 2px #DCF0FF"}]
  [:&:enabled [:&:hover {:background "#2450E1"}]]
  [:&:active {:background "#1840C1"
              :box-shadow "none"}]
  [:&:disabled :grayscale :cursor-not-allowed])
